import moment from 'moment-timezone'
import { Alert } from 'antd'
import {
    DFM_APPROVED,
    DFM_PENDING_REVISION,
    DFM_WARNING_ACCEPTED,
    ImDfmStateType,
} from '@Admin/AdminQuotingPage/ImDfmSlidesPanel/ImDfmSlide/constants'

import Box from '~/core/Box'
import Text from '~/core/Text'
import getColor from '~/lib/getColor'
import { DFM_STATUS_ACTIONS } from '../constants'

const DATE_FORMAT = 'LL [at] h:mm A z'
const VALID_STATUSES = new Set([
    DFM_APPROVED,
    DFM_PENDING_REVISION,
    DFM_WARNING_ACCEPTED,
])

type AlertDescriptionPropsType = {
    acceptedAt?: string
    acceptedByEmail?: string
    description?: string
    status: string
}

const AlertDescription = (props: AlertDescriptionPropsType) => {
    const { acceptedAt, acceptedByEmail, description, status } = props

    if (description) {
        return (
            <Text color="blackAlpha65" fontSize="14px">
                {description}
            </Text>
        )
    }

    if (!acceptedAt || !acceptedByEmail || !VALID_STATUSES.has(status)) {
        return null
    }

    return (
        <Text color="blackAlpha65" fontSize="14px">
            {acceptedByEmail}
            <br />
            {moment(acceptedAt).format(DATE_FORMAT)}
        </Text>
    )
}

type SlideStatusAlertPropsType = {
    acceptedAt?: string
    acceptedByEmail?: string
    status: ImDfmStateType
}

const SlideStatusAlert = (props: SlideStatusAlertPropsType) => {
    const { acceptedAt, acceptedByEmail, status } = props

    const alertType = DFM_STATUS_ACTIONS[status]?.type
    const message = DFM_STATUS_ACTIONS[status]?.message
    const description = DFM_STATUS_ACTIONS[status]?.description

    if (alertType) {
        return (
            <Alert
                description={
                    <AlertDescription
                        acceptedAt={acceptedAt}
                        acceptedByEmail={acceptedByEmail}
                        description={description}
                        status={status}
                    />
                }
                message={
                    <Text color="blackAlpha85" fontSize="16px" fontWeight={500}>
                        {message}
                    </Text>
                }
                style={{ marginBottom: '8px', padding: '16px' }}
                type={alertType}
            />
        )
    }

    return (
        <Box
            backgroundColor="grey2"
            border={`1px solid ${getColor('blackAlpha15')}`}
            borderRadius="4px"
            padding="16px"
            marginBottom="8px"
        >
            <Text color="blackAlpha85" fontSize="16px" fontWeight={500}>
                {message}
            </Text>
        </Box>
    )
}

export default SlideStatusAlert
